//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "progressDetail",
    data() {
        return {
            id: 0,
            projectProgress: {}
        }
    },
    methods: {
        getProjectProgressById(id) {
            abp.ajax.get('/api/services/app/ProjectProgress/GetProjectProgress?id=' + id).then(res => {
                this.projectProgress = {};
                this.projectProgress = res.data.result;
            })
        }
    },
    created() {
        this.id = parseInt(this.$route.params.id) || 0;
        if (this.id > 0) {
            this.getProjectProgressById(this.id);
        }
    }
}
